<template>
    <div>
        <!-- Modal-->
        <div class="modal fade" id="rejectReturnModal" data-backdrop="static" tabindex="-1" role="dialog"
             aria-labelledby="staticBackdrop" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Submit Return</h5>
                        <button ref="closeModalButton" type="button" class="close" data-dismiss="modal"
                                aria-label="Close">
                            <i aria-hidden="true" class="ki ki-close"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label class="font-weight-bold">Select quantity to return</label>
                            <input type="number" class="form-control" :max="orderRefund.quantity_refunded"
                                   v-model="quantity">
                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold">Select reason</label>
                            <div v-for="(reason, key) in rejectReasons">
                                <div class="checkbox-inline">
                                    <label class="checkbox checkbox-danger">
                                        <input name="reason" type="radio" :value="key"
                                               @change="e => selectedReason = e.target.value">
                                        <span></span>
                                        {{ reason }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <button class="btn btn-danger" @click="submit" :disabled="selectedReason === ''">
                                <i class="fas fa-check-square"/>
                                Reject return
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Button -->
        <button ref="toggle" class="btn btn-sm btn-block btn-light-danger" data-toggle="modal"
                data-target="#rejectReturnModal">
            <i class="fas fa-times"/>
            Reject Return
        </button>
    </div>
</template>

<script>
export default {
    props: {
        orderRefund: Object
    },

    data() {
        return {
            quantity: this.orderRefund.quantity_refunded,
            selectedReason: '',
            rejectReasons: {
                defective: 'Article Defect',
                customer_damaged: 'Customer Damaged',
                carrier_damaged: 'Carrier Damaged',
            }
        }
    },

    methods: {
        submit() {
            this.$emit('submit', {
                reason: this.selectedReason,
                quantity: this.quantity
            })
            this.$refs.toggle.click();
        }
    }
}
</script>
